/* Praevaleo Kopf: Ankündigung drehen, Kopf über dem Hero (Startseite) beim Scrollen weiß und fest, Suche öffnen. */
(() => {
  if (window.__pvChrome) return;
  window.__pvChrome = true;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function initAnn() {
    $$('[data-pv-ann]').forEach((ann) => {
      if (ann.dataset.on) return;
      ann.dataset.on = '1';
      const msgs = $$('.pv-ann__msg', ann);
      if (msgs.length < 2) return;
      let i = 0, timer = null, paused = false;
      const ms = Math.max(3, +ann.dataset.speed || 4) * 1000;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const show = (n) => {
        i = (n + msgs.length) % msgs.length;
        msgs.forEach((m, k) => {
          const on = k === i;
          m.classList.toggle('is-on', on);
          m.setAttribute('aria-hidden', String(!on));
          const a = m.querySelector('a');
          if (a) a.tabIndex = on ? 0 : -1;
        });
      };
      const run = () => { clearInterval(timer); if (!reduce && !paused) timer = setInterval(() => show(i + 1), ms); };
      ann.addEventListener('click', (e) => {
        const b = e.target.closest('[data-pv-ann-step]');
        if (!b) return;
        show(i + +b.dataset.pvAnnStep);
        run();
      });
      ann.addEventListener('mouseenter', () => { paused = true; run(); });
      ann.addEventListener('mouseleave', () => { paused = false; run(); });
      ann.addEventListener('focusin', () => { paused = true; run(); });
      ann.addEventListener('focusout', () => { paused = false; run(); });
      document.addEventListener('visibilitychange', () => { paused = document.hidden; run(); });
      run();
    });
  }

  // Startseite: Kopf liegt über dem Hero und scrollt mit; danach kommt er weiß und fest zurück.
  function initOver() {
    const hdr = $('.pv-hdr--over');
    if (!hdr || hdr.dataset.on) return;
    hdr.dataset.on = '1';
    // Feinschliff 02.11.: kein Scroll-Listener mehr. Ein unsichtbarer Marker (Kopfhöhe + 40 px) meldet per
    // IntersectionObserver, wann der Kopf fest werden soll; während des Scrollens läuft so kein Skript.
    let fixed = false;
    const update = () => {
      const mega = document.documentElement.classList.contains('pv-mega-open');
      hdr.classList.toggle('is-fixed', fixed);
      hdr.classList.toggle('is-solid', fixed || mega);
    };
    if ('IntersectionObserver' in window) {
      let mark = document.querySelector('[data-pv-hdr-mark]');
      if (!mark) {
        mark = document.createElement('div');
        mark.setAttribute('data-pv-hdr-mark', '');
        mark.setAttribute('aria-hidden', 'true');
        mark.style.cssText = 'position:absolute;top:0;left:0;width:1px;height:calc(var(--pv-ann-h) + var(--pv-bar-over) + 40px);pointer-events:none;visibility:hidden';
        document.body.prepend(mark);
      }
      new IntersectionObserver((es) => { fixed = !es[es.length - 1].isIntersecting; update(); }).observe(mark);
    } else {
      fixed = false;
    }
    new MutationObserver(update).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    update();
  }

  // Suche: Horizon-Suchfenster, sonst Suchseite.
  document.addEventListener('click', (e) => {
    const t = e.target instanceof Element ? e.target.closest('[data-pv-search]') : null;
    if (!t || e.metaKey || e.ctrlKey) return;
    const modal = document.getElementById('search-modal');
    if (modal && typeof modal.showDialog === 'function') {
      e.preventDefault();
      const menu = $('[data-pv-drawer]');
      if (menu && !menu.hidden) $('[data-pv-drawer-close]', menu)?.click();
      modal.showDialog();
    }
  });

  // Merkliste (wie insomne): Handles in localStorage, Zähler am Herz im Kopf. Alte Einzel-Schlüssel pv-fav-* werden übernommen.
  const MK = 'pv-merkliste';
  const read = () => { try { const l = JSON.parse(localStorage.getItem(MK) || '[]'); return Array.isArray(l) ? l : []; } catch (e) { return []; } };
  const write = (l) => { try { localStorage.setItem(MK, JSON.stringify(l)); } catch (e) {} };
  try {
    const l = read(); let moved = false;
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k && k.indexOf('pv-fav-') === 0) { const h = k.slice(7); if (h && !l.includes(h)) l.push(h); localStorage.removeItem(k); moved = true; }
    }
    if (moved) write(l);
  } catch (e) {}
  const paint = () => {
    const n = read().length;
    $$('[data-pv-merk-count]').forEach((b) => { b.textContent = n; b.hidden = !n; });
    $$('[data-pv-merk]').forEach((a) => a.setAttribute('aria-label', 'Merkliste, ' + n + (n === 1 ? ' Teil' : ' Teile')));
  };
  window.pvMerk = {
    list: read,
    has: (h) => read().includes(h),
    set: (h, on) => { let l = read().filter((x) => x !== h); if (on) l.unshift(h); write(l); paint(); document.dispatchEvent(new CustomEvent('pv:merk', { detail: { list: l } })); },
  };
  window.addEventListener('storage', (e) => { if (e.key === MK) paint(); });
  window.addEventListener('pageshow', paint);

  // Menü-Knopf: aria-expanded mit dem Seitenfach abgleichen.
  const menu = $('[data-pv-drawer]');
  if (menu) new MutationObserver(() => $$('[data-pv-menu]').forEach((b) => b.setAttribute('aria-expanded', String(!menu.hidden)))).observe(menu, { attributes: true, attributeFilter: ['hidden'] });

  const init = () => { initAnn(); initOver(); paint(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', () => { $$('[data-pv-ann]').forEach((a) => delete a.dataset.on); $$('.pv-hdr--over').forEach((h) => delete h.dataset.on); init(); });
})();
/* Schnell hinzufügen (Fehlerbericht 02.11., Punkt 9): das Plus auf jeder Produktkarte öffnet ein kleines Fenster mit
   Größenwahl ohne Vorauswahl; „In den Warenkorb“ legt das Teil hinein und öffnet das Warenkorb-Fach (cart:update). */
(() => {
  if (window.__pvQuick) return;
  window.__pvQuick = true;
  const SEL = '.pvh-plus, .pv-card__plus, .pv-rec__plus';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const fmt = (c) => '€' + (c / 100).toFixed(2).replace('.', ','); // wie der Shop: €84,90
  let dlg = null, prod = null, pick = null, opener = null;
  const prep = (ctx) => (ctx || document).querySelectorAll(SEL).forEach((p) => {
    if (p.dataset.q) return;
    p.dataset.q = '1';
    p.removeAttribute('aria-hidden');
    p.setAttribute('role', 'button');
    p.setAttribute('tabindex', '0');
    p.setAttribute('aria-label', 'Schnell in den Warenkorb');
  });
  function build() {
    dlg = document.createElement('dialog');
    dlg.className = 'pv-quick';
    dlg.setAttribute('aria-labelledby', 'pv-quick-t');
    dlg.innerHTML = '<button type="button" class="pv-quick__x" data-x aria-label="Schließen"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<div class="pv-quick__top"><img class="pv-quick__img" alt="" width="72" height="90"><div><p class="pv-quick__t" id="pv-quick-t" tabindex="-1" autofocus></p><p class="pv-quick__p"></p></div></div>' +
      '<p class="pv-quick__h">Größe wählen</p><div class="pv-quick__opts" role="group" aria-label="Größe"></div>' +
      '<p class="pv-quick__msg" role="status"></p><button type="button" class="pv-quick__add" data-add disabled>Größe wählen</button>';
    document.body.appendChild(dlg);
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg || e.target.closest('[data-x]')) { dlg.close(); return; }
      const o = e.target.closest('.pv-quick__o');
      if (o && !o.disabled) {
        sel[+o.dataset.pos] = o.dataset.val;
        sync();
        return;
      }
      if (e.target.closest('[data-add]')) add();
    });
    dlg.addEventListener('close', () => { document.documentElement.classList.remove('pv-lock'); if (opener && opener.focus) opener.focus({ preventScroll: true }); });
  }
  let sel = [];
  // Auswahl abgleichen: Knöpfe ohne lieferbare Kombination aus, Variante erst bei voller Auswahl.
  function sync() {
    const add = dlg.querySelector('[data-add]');
    dlg.querySelectorAll('.pv-quick__o').forEach((b) => {
      const pos = +b.dataset.pos, val = b.dataset.val;
      const ok = prod.variants.some((v) => v.available && v.options[pos] === val && v.options.every((x, i) => i === pos || sel[i] === null || sel[i] === x));
      b.disabled = !ok;
      b.setAttribute('aria-pressed', String(sel[pos] === val));
      if (!ok && sel[pos] === val) sel[pos] = null;
    });
    const v = sel.every((x) => x !== null) ? prod.variants.find((x) => x.options.every((o, i) => o === sel[i])) : null;
    pick = v && v.available ? v.id : null;
    if (v) dlg.querySelector('.pv-quick__p').textContent = fmt(v.price);
    add.disabled = !pick;
    const missing = dlg.querySelector('.pv-quick__row:not(:has([aria-pressed="true"]))');
    add.textContent = pick ? 'In den Warenkorb' : (v && !v.available ? 'Ausverkauft' : (missing ? (missing.getAttribute('aria-label') + ' wählen') : 'Auswählen'));
  }
  async function add() {
    const btn = dlg.querySelector('[data-add]'), msg = dlg.querySelector('.pv-quick__msg');
    if (!pick || btn.disabled) return;
    btn.disabled = true; btn.textContent = 'Wird hinzugefügt';
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: pick, quantity: 1 }] }) });
      if (!r.ok) throw new Error(String(r.status));
      opener = null; // Fokus bleibt im Warenkorb-Fach
      dlg.close();
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { data: { source: 'pv-quick' } } }));
    } catch (e) {
      msg.textContent = 'Das hat nicht geklappt. Bitte versuch es noch einmal.';
      btn.disabled = false; btn.textContent = 'In den Warenkorb';
    }
  }
  async function openFor(plus) {
    const a = plus.closest('a[href]');
    if (!a) return;
    opener = plus;
    if (!dlg) build();
    const url = new URL(a.href, location.href); url.search = ''; url.hash = '';
    let p = null;
    try { p = await fetch(url.pathname.replace(/\/$/, '') + '.js').then((r) => (r.ok ? r.json() : null)); } catch (e) {}
    if (!p) { location.href = a.href; return; }
    prod = p; pick = null;
    const v0 = p.variants.length === 1 ? p.variants[0] : null;
    dlg.querySelector('.pv-quick__t').textContent = p.title;
    dlg.querySelector('.pv-quick__p').textContent = (p.price_varies ? 'ab ' : '') + fmt(p.price);
    const im = dlg.querySelector('.pv-quick__img');
    const fi = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : '';
    im.src = fi ? fi + (fi.indexOf('?') > -1 ? '&' : '?') + 'width=216' : ''; im.hidden = !fi;
    dlg.querySelector('.pv-quick__msg').textContent = '';
    // Je Option eine Reihe (z. B. Farbe, Größe). Optionen mit nur einem Wert sind gesetzt, sonst keine Vorauswahl.
    const opts = (p.options || []).map((o, i) => ({ name: o.name || o, pos: i, values: o.values || [...new Set(p.variants.map((v) => v.options[i]))] }));
    sel = opts.map((o) => (o.values.length === 1 ? o.values[0] : null));
    const box = dlg.querySelector('.pv-quick__opts'); box.replaceChildren();
    dlg.querySelector('.pv-quick__h').hidden = true;
    opts.filter((o) => o.values.length > 1).forEach((o) => {
      const h = document.createElement('p'); h.className = 'pv-quick__h'; h.textContent = o.name; box.appendChild(h);
      const row = document.createElement('div'); row.className = 'pv-quick__row'; row.setAttribute('role', 'group'); row.setAttribute('aria-label', o.name);
      o.values.forEach((val) => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'pv-quick__o'; b.dataset.pos = o.pos; b.dataset.val = val; b.textContent = val;
        b.setAttribute('aria-pressed', 'false');
        row.appendChild(b);
      });
      box.appendChild(row);
    });
    if (v0) pick = v0.id;
    sync();
    document.documentElement.classList.add('pv-lock');
    dlg.showModal();
  }
  const hit = (e) => { const t = e.target instanceof Element ? e.target.closest(SEL) : null; return t; };
  document.addEventListener('click', (e) => { const p = hit(e); if (!p) return; e.preventDefault(); e.stopPropagation(); openFor(p); }, true);
  document.addEventListener('keydown', (e) => { if (e.key !== 'Enter' && e.key !== ' ') return; const p = hit(e); if (!p) return; e.preventDefault(); e.stopPropagation(); openFor(p); }, true);
  const go = () => { prep(); let q = 0; new MutationObserver(() => { if (!q) q = requestAnimationFrame(() => { q = 0; prep(); }); }).observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
/* Herz auf Produktkarten: Merkliste umschalten, ohne den Link zu öffnen */
(() => {
  if (window.__pvCHeart) return;
  window.__pvCHeart = true;
  const mark = () => document.querySelectorAll('[data-pv-cheart]').forEach((h) => {
    const on = !!(window.pvMerk && window.pvMerk.has(h.dataset.pvCheart));
    h.setAttribute('aria-pressed', String(on));
    if (!h.dataset.q) { h.dataset.q = '1'; h.setAttribute('role', 'button'); h.setAttribute('tabindex', '0'); }
    h.setAttribute('aria-label', on ? 'Von der Merkliste nehmen' : 'Merken');
  });
  const toggle = (e) => {
    const h = e.target instanceof Element ? e.target.closest('[data-pv-cheart]') : null;
    if (!h) return;
    if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
    e.preventDefault(); e.stopPropagation();
    if (window.pvMerk) window.pvMerk.set(h.dataset.pvCheart, h.getAttribute('aria-pressed') !== 'true');
    mark();
  };
  document.addEventListener('click', toggle, true);
  document.addEventListener('keydown', toggle, true);
  document.addEventListener('pv:merk', mark);
  const go = () => { mark(); let q = 0; new MutationObserver(() => { if (!q) q = requestAnimationFrame(() => { q = 0; mark(); }); }).observe(document.body, { childList: true, subtree: true }); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go); else go();
})();
